// src/pages/CoinsThanks.js  —  route: /coins/thanks
// Stripe sends the buyer here after paying for a coin pack. We confirm the
// payment with the server (which adds the coins once — the webhook may have
// already), celebrate, and send them back where they came from.

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import { confirmCoinPurchase } from "../services/coinStoreService";
import CoinCounter from "../components/coins/CoinCounter";

export default function CoinsThanks() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "working" });
  const back = params.get("back") || "/dashboard";

  useEffect(() => {
    const sessionId = params.get("session_id");
    const stop = onAuthStateChanged(auth, async (user) => {
      if (!user) return navigate("/login", { replace: true });
      if (!sessionId) return setState({ status: "missing" });
      for (let i = 0; i < 6; i += 1) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const out = await confirmCoinPurchase(sessionId);
          if (out?.status === "paid") {
            setState({ status: "done", ...out });
            // no popup here: this page already says what was added, and the
            // account the coins went to pops up by itself (CoinCelebration
            // watches its ledger)
            return undefined;
          }
        } catch (e) {
          setState({ status: "error", message: e?.message });
          return undefined;
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, 1500));
      }
      setState({ status: "pending" });
      return undefined;
    });
    return () => stop();
  }, [params, navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#fff7e0", fontFamily: '"Baloo 2", "Fredoka", sans-serif', padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "28px 32px", textAlign: "center", maxWidth: 480, boxShadow: "0 18px 40px rgba(0,0,0,0.15)", border: "4px solid #ffcf4a" }}>
        {state.status === "working" && <h2>Adding your coins…</h2>}
        {state.status === "done" && (
          <>
            <h2 style={{ margin: 0 }}>Thank you! 🎉</h2>
            <p style={{ fontSize: 18 }}>
              {state.target === "classBank"
                ? `${state.coins} coins were added to your class coin bank (${(state.classBank || 0).toLocaleString()} now).`
                : `${state.coins} coins were added to the account.`}
            </p>
            {state.target !== "classBank" && <CoinCounter size="lg" />}
          </>
        )}
        {state.status === "pending" && <p>Your payment is still being confirmed. The coins will appear in a minute or two.</p>}
        {state.status === "missing" && <p>We couldn't find that purchase.</p>}
        {state.status === "error" && <p>Something went wrong: {state.message}. If you were charged, the coins will still be added — or contact us.</p>}
        <button type="button" onClick={() => navigate(back, { replace: true })} style={{ marginTop: 14, border: 0, borderRadius: 12, padding: "10px 22px", background: "#22b455", color: "#fff", fontWeight: 900, fontSize: 17, cursor: "pointer" }}>
          Back
        </button>
      </div>
    </div>
  );
}
